import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, CreditCard } from 'lucide-react';
import { useUserData } from '../../hooks/useUserData';
import { posthog } from '../../providers/PostHogProvider';

/**
 * Full-page interstitial shown when subscription state is SUSPENDED.
 * Only super_admin sees the "Manage Billing" button.
 */
const SuspendedPage: React.FC = () => {
  const navigate = useNavigate();
  const { userData } = useUserData();
  const isSuperAdmin = userData?.role === 'super_admin';

  useEffect(() => {
    try { posthog?.capture('subscription_state_page_viewed', { state: 'suspended' }); } catch {}
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 px-4">
      <div className="max-w-md w-full bg-gray-800/50 border border-gray-700 rounded-2xl p-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-900/30 border border-red-700/50 mb-4">
          <Lock className="text-red-400" size={32} />
        </div>
        <h1 className="text-2xl font-bold text-white mb-2">Account Suspended</h1>
        <p className="text-gray-400 mb-6">
          Your subscription payment could not be processed and the grace period has expired.
          Please update your payment method to restore access.
        </p>
        <div className="space-y-3">
          {isSuperAdmin && (
            <button
              onClick={() => navigate('/settings/billing')}
              className="flex items-center justify-center gap-2 w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              <CreditCard size={18} />
              Manage Billing
            </button>
          )}
          <a
            href="mailto:support@valutten.com"
            className="flex items-center justify-center gap-2 w-full py-3 bg-gray-700 text-white rounded-lg hover:bg-gray-600 transition-colors font-medium"
          >
            <Mail size={18} />
            Contact Support
          </a>
        </div>
        {!isSuperAdmin && (
          <p className="text-sm text-gray-500 mt-6">
            Please ask your account administrator to update the payment method.
          </p>
        )}
      </div>
    </div>
  );
};

export default SuspendedPage;
